/* TSC live chat — AI answers when no staff is on shift, staff take over when they are */
(function () {
  var root = document.getElementById("tscChat");
  if (!root) return;
  var W = (root.getAttribute("data-worker") || "").replace(/\/$/, "");
  if (!W) return;
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (v) { var d = document.createElement("i"); d.textContent = v == null ? "" : String(v); return d.innerHTML; };

  var threadId = null;
  var lastAt = 0;
  var open = false;
  var poller = null;

  /* ── background polling budget ──────────────────────────────────────────────
     This used to be a flat setInterval(poll, 20000) that ran forever, in every
     tab, on every page, for anyone who had ever opened the chat. Now:
       - nothing polls while the tab is hidden (and one catch-up poll fires the
         moment it becomes visible again),
       - the closed-widget interval backs off 20s -> 30s -> 45s -> 60s,
       - it stops entirely after ~10 minutes with no new message, and resumes on
         the next real interaction or when the widget is opened.
     The OPEN widget still polls a flat 5s, unchanged. ─────────────────────── */
  var OPEN_MS = 5000;
  var BACKOFF = [20000, 30000, 45000, 60000];
  var IDLE_GIVE_UP_MS = 10 * 60 * 1000;
  var backoffStep = 0;
  var lastMessageAt = Date.now();
  var stopped = false;

  try { threadId = localStorage.getItem("tsc_chat_id") || null; } catch (e) {}

  function visible() { return document.visibilityState !== "hidden"; }

  function clearPoller() { if (poller) { clearInterval(poller); poller = null; } }

  function schedule() {
    clearPoller();
    if (open) { poller = setInterval(tick, OPEN_MS); return; }   // unchanged 5s cadence
    if (!threadId || stopped || !visible()) return;
    poller = setInterval(tick, BACKOFF[backoffStep]);
  }

  /* One poll plus the bookkeeping that decides whether to keep going. */
  function tick() {
    if (!visible()) { clearPoller(); return; }
    if (!open) {
      if (Date.now() - lastMessageAt > IDLE_GIVE_UP_MS) { stopped = true; clearPoller(); return; }
      var next = Math.min(backoffStep + 1, BACKOFF.length - 1);
      if (next !== backoffStep) { backoffStep = next; schedule(); }
    }
    poll();
  }

  /* Called whenever something real happens: reset the backoff and start again. */
  function wake() {
    lastMessageAt = Date.now();
    backoffStep = 0;
    stopped = false;
    schedule();
  }

  function addMsg(m) {
    var cls = m.role === "visitor" ? "cw-me" : (m.role === "staff" ? "cw-staff" : "cw-ai");
    var who = m.role === "staff" ? '<span class="cw-who">Shop team</span>' : "";
    var el = document.createElement("div");
    el.className = "cw-msg " + cls;
    el.innerHTML = '<span class="cw-bubble">' + who + esc(m.text) + "</span>";
    $("cwLog").appendChild(el);
    $("cwLog").scrollTop = $("cwLog").scrollHeight;
    if (m.at && m.at > lastAt) lastAt = m.at;
    lastMessageAt = Date.now();
    backoffStep = 0;
    stopped = false;
  }

  function status(on) {
    var el = $("cwStatus");
    el.textContent = on ? "A team member is here" : "Ask us anything";
    el.className = on ? "on" : "";
    $("cwFoot").textContent = on
      ? "You're talking to the shop team."
      : "Answers come from our assistant unless a team member is on.";
  }

  function typing(on) { $("cwTyping").hidden = !on; if (on) $("cwLog").scrollTop = $("cwLog").scrollHeight; }

  function send() {
    var text = $("cwText").value.trim();
    if (!text) return;
    wake();   // sending is a real interaction: reset the backoff budget
    $("cwText").value = "";
    addMsg({ role: "visitor", text: text, at: Date.now() });
    $("cwSend").disabled = true;
    typing(true);
    fetch(W + "/chat/message", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: threadId, text: text }),
    }).then(function (r) { return r.json(); }).then(function (j) {
      typing(false);
      if (j.id && j.id !== threadId) {
        threadId = j.id;
        try { localStorage.setItem("tsc_chat_id", threadId); } catch (e) {}
      }
      status(!!j.staffOnline);
      // render anything newer than what we already have (the AI reply, or nothing if staff will answer)
      (j.messages || []).forEach(function (m) { if (m.at > lastAt && m.role !== "visitor") addMsg(m); });
      if (j.staffOnline) {
        addMsg({ role: "ai", text: "Someone from the shop is on — hang tight, they'll reply here shortly.", at: Date.now() });
      }
    }).catch(function () {
      typing(false);
      addMsg({ role: "ai", text: "That didn't send. Give us a call on 324-200-8945 and we'll sort it out.", at: Date.now() });
    }).finally(function () { $("cwSend").disabled = false; $("cwText").focus(); });
  }

  function poll() {
    if (!threadId) return;
    fetch(W + "/chat/poll?id=" + encodeURIComponent(threadId) + "&since=" + lastAt, { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        status(!!j.staffOnline);
        (j.messages || []).forEach(function (m) {
          if (m.role !== "visitor") {
            addMsg(m);
            if (!open) { $("cwBadge").hidden = false; }
          } else if (m.at > lastAt) { lastAt = m.at; }
        });
      }).catch(function () {});
  }

  function history() {
    if (!threadId) return;
    fetch(W + "/chat/poll?id=" + encodeURIComponent(threadId) + "&since=0", { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.messages && j.messages.length) {
          $("cwLog").innerHTML = "";
          j.messages.forEach(addMsg);
        }
        status(!!j.staffOnline);
      }).catch(function () {});
  }

  $("cwLaunch").addEventListener("click", function () {
    open = true;
    $("cwPanel").hidden = false;
    $("cwLaunch").hidden = true;
    $("cwBadge").hidden = true;
    history();
    $("cwText").focus();
    wake();
  });
  $("cwClose").addEventListener("click", function () {
    open = false;
    $("cwPanel").hidden = true;
    $("cwLaunch").hidden = false;
    wake();   // drop back to the backed-off closed-widget cadence
  });
  $("cwSend").addEventListener("click", send);
  $("cwText").addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });

  // A hidden tab polls nothing. Coming back polls once immediately, then resumes.
  document.addEventListener("visibilitychange", function () {
    if (!visible()) { clearPoller(); return; }
    if (open) { poll(); schedule(); return; }
    if (threadId && !stopped) { poll(); schedule(); }
  });

  // Any real interaction with the page resumes a poller that gave up on idle.
  ["pointerdown", "keydown"].forEach(function (ev) {
    document.addEventListener(ev, function () {
      if (!threadId || !stopped || !visible()) return;
      wake();
      poll();
    }, { passive: true });
  });

  // keep listening in the background so a staff reply can nudge the badge
  if (threadId) schedule();
})();
